// Production bucket — station idle past threshold (§5.6 / SC-8 defer).
//
// Structural stub: `useProductionStationIdleCount` returns 0 until
// `mfgFulfill` station state lands. Registry declares `hasSignal:
// () => false` so the dock never peeks on fabricated data.

/**
 * Stub data source. Returns stations idle longer than the org threshold.
 * Future slice replaces this with `mfgFulfill` scaffold aggregates.
 */
function useProductionStationIdleCount(): number {
  return 0;
}

export function ActivityDockProductionStationIdleSection() {
  const count = useProductionStationIdleCount();

  if (count <= 0) return null;

  return (
    <section
      aria-label="Production station idle reminder"
      className="mt-3 rounded-lg border border-amber-300 bg-amber-50 p-3 dark:border-amber-500/60 dark:bg-amber-950/30"
    >
      <h3 className="text-[11px] font-semibold uppercase tracking-wide text-amber-900 dark:text-amber-200">
        Stations idle
      </h3>
      <p className="mt-1 text-[12px] text-amber-900 dark:text-amber-200">
        {count} {count === 1 ? "station has" : "stations have"} been idle past
        the threshold. Review builds in Production → Fulfillment.
      </p>
    </section>
  );
}
